// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  font-size: 15px;
  text-align: center;
  max-width: 300px;
  justify-content: center !important;
}

.confirm {
  color: #188ad2;
}

.cancel {
  color: red;
}

.img-icon {
  height: 70px;
}

.ml-5 {
  margin-left: 5px;
}

.pt-15 {
  padding-top: 15px;
}

.title {
  font-size: 16px;
  font-weight: bold;
  word-wrap: break-word;
}

.buttons {
  justify-content: center !important;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFsZXJ0LmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsZUFBQTtFQUNBLGtCQUFBO0VBQ0EsZ0JBQUE7RUFDQSxrQ0FBQTtBQUNGOztBQUVBO0VBQ0UsY0FBQTtBQUNGOztBQUVBO0VBQ0UsVUFBQTtBQUNGOztBQUVBO0VBQ0UsWUFBQTtBQUNGOztBQUVBO0VBQ0UsZ0JBQUE7QUFDRjs7QUFFQTtFQUNFLGlCQUFBO0FBQ0Y7O0FBRUE7RUFDRSxlQUFBO0VBQ0EsaUJBQUE7RUFDQSxxQkFBQTtBQUNGOztBQUVBO0VBQ0Usa0NBQUE7QUFDRiIsImZpbGUiOiJhbGVydC5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbInAge1xuICBmb250LXNpemU6IDE1cHg7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgbWF4LXdpZHRoOiAzMDBweDtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXIgIWltcG9ydGFudDtcbn1cblxuLmNvbmZpcm0ge1xuICBjb2xvcjogIzE4OGFkMjtcbn1cblxuLmNhbmNlbCB7XG4gIGNvbG9yOiByZWQ7XG59XG5cbi5pbWctaWNvbiB7XG4gIGhlaWdodDogNzBweDtcbn1cblxuLm1sLTUge1xuICBtYXJnaW4tbGVmdDogNXB4O1xufVxuXG4ucHQtMTUge1xuICBwYWRkaW5nLXRvcDogMTVweDtcbn1cblxuLnRpdGxlIHtcbiAgZm9udC1zaXplOiAxNnB4O1xuICBmb250LXdlaWdodDogYm9sZDtcbiAgd29yZC13cmFwOiBicmVhay13b3JkO1xufVxuXG4uYnV0dG9ucyB7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyICFpbXBvcnRhbnQ7XG59Il19 */`, "",{"version":3,"sources":["webpack://./src/app/basic/alert/alert.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kCAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,qBAAA;AACF;;AAEA;EACE,kCAAA;AACF;AACA,wjCAAwjC","sourcesContent":["p {\n  font-size: 15px;\n  text-align: center;\n  max-width: 300px;\n  justify-content: center !important;\n}\n\n.confirm {\n  color: #188ad2;\n}\n\n.cancel {\n  color: red;\n}\n\n.img-icon {\n  height: 70px;\n}\n\n.ml-5 {\n  margin-left: 5px;\n}\n\n.pt-15 {\n  padding-top: 15px;\n}\n\n.title {\n  font-size: 16px;\n  font-weight: bold;\n  word-wrap: break-word;\n}\n\n.buttons {\n  justify-content: center !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
